var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1562 16.2261L19.3163 9.06613C19.6063 8.77613 20.0763 8.77613 20.3763 9.06613C20.6763 9.35613 20.6663 9.83613 20.3763 10.1261L14.2763 16.2261L20.5363 22.4761C20.8263 22.7661 20.8263 23.2461 20.5363 23.5361C20.2463 23.8261 19.7663 23.8261 19.4763 23.5361L12.1563 16.2161L12.1562 16.2261Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBack);
export default __webpack_public_path__ + "static/media/Ico_back.c1438ee320afdb622837625aaa4c0211.svg";
export { ForwardRef as ReactComponent };